import type { ToolId } from "./tools";

export interface GenerateRequest {
  tool: ToolId;
  inputs: Record<string, string | number | boolean | string[]>;
  onboarding?: Record<string, string | boolean>;
  locale?: "en" | "zh";
}

export interface GenerateSuccess {
  ok: true;
  tool: string;
  model: string;
  output: Record<string, string | string[]>;
  usage?: unknown;
}

export interface GenerateFailure {
  ok: false;
  code: "missing_api_key" | "invalid_input" | "rate_limited" | "model_unavailable" | "upstream_error";
  message: string;
}

export type GenerateResponse = GenerateSuccess | GenerateFailure;

export async function generateContent(request: GenerateRequest): Promise<GenerateResponse> {
  const response = await fetch("/api/generate", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(request)
  });

  const data = (await response.json()) as GenerateResponse;
  return data;
}

export async function getHealth(): Promise<{ ok: boolean; openrouterConfigured: boolean; primaryModel: string }> {
  const response = await fetch("/api/health");
  return (await response.json()) as { ok: boolean; openrouterConfigured: boolean; primaryModel: string };
}
